module.exports = __webpack_public_path__ + "media/boing.e42b7b5b.mp3";